import { createI18n } from 'vue-i18n';
import type { I18n } from 'vue-i18n';

import messages from '@/lang';
import { languages } from '@/constants/languages';

export const i18n = createI18n({
  locale: languages[0]?.locale ?? 'en',
  legacy: false,
  messages,
  globalInjection: true
});

function initI18n(): I18n {
  const localeMessage: Record<string, Record<string, string>> = {
    ...(messages as unknown as Record<string, Record<string, string>>)
  };

  //   const userPreferences = app.$cookies.get("userPreferences") ?? {};
  const language = languages[0];

  return createI18n({
    locale: language?.locale ?? 'en', // set fallback locale
    legacy: false, // you must set `false`, to use Compostion API
    messages: localeMessage, // set locale messages
    globalInjection: true
  });
}

export default initI18n;
